module.exports = __webpack_public_path__ + "static/media/down-arrow.3ffceac6.svg";